export const Product = ({ product }) => {
  return (
    <div
      className="product-container"
      onClick={() => {
        window.open(product.navigate, "_blank");
      }}
    >
      <div className="image-container">
        <img src={product.image} alt="product" />
      </div>
      <div>
        <p>{product.name}</p>
      </div>
    </div>
  );
};
